import * as model from './models';

import createAxios from '@framework/http';
const axios = createAxios({ keys: 'userInfo.shopId', DEBUG: process.env.VUE_APP_NODE_ENV !== 'production' });

/** Ad Center Controller  查询商家的推广账户状态 */
export async function accountStatusUsingGET() {
    const result = await axios.get<model.IMessageAdPermissionVO>(`/rest/op/vc/merchant/adCenter/accountStatus`);
    return result;
}

/** Ad Center Controller  提交商家联系方式给广告平台 */
export async function submitContactUsingPOST(params: { param: model.IApplyAdContactParam }) {
    const result = await axios.post<model.IMessagestring>(`/rest/op/vc/merchant/adCenter/submitContact`, {
        ...params.param,
    });
    return result;
}
